import { render, staticRenderFns } from "./TabsScroll.vue?vue&type=template&id=2f6cb68c&"
import script from "./TabsScroll.vue?vue&type=script&lang=ts&"
export * from "./TabsScroll.vue?vue&type=script&lang=ts&"
import style0 from "./TabsScroll.vue?vue&type=style&index=0&id=2f6cb68c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports